// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_full_routine:"Your Go-To Kit",
  section_basics:"Your Custom Routine"
  
}

// Add default image url here
const tangent_default_selfie_image_url= {
    "straight":"https://file.tangent.ai/quiz-content/merchants/umberto-giannini/image/17471324814483524-Straight.png",
    "wavy":"https://file.tangent.ai/quiz-content/merchants/umberto-giannini/image/2245986627489418-Wavy.png",
    "curly":"https://file.tangent.ai/quiz-content/merchants/umberto-giannini/image/8988468529419393-Curly.png",
    "coily":"https://file.tangent.ai/quiz-content/merchants/umberto-giannini/image/22598819307827855-Coily.png"
}

const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", (event) => {
    onLoadFunction();
  });
} else {
  onLoadFunction();
}

function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  let tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);

      // Used for spider chart creation
    if(response["selfie_id"]!=null){
      getSelfieMapping(response["selfie_id"]);
      setElementDisplay("section_chart_container","flex");
    }
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setIfTabEnabled(response.tags);
  
    setSelfieHairType(response.tags);  
    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData();  
      customFunction(response);    
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

// For Duplicated Quizzes
function setIfTabEnabled(tags) {
  const hiddenTags = ["boots_quiz", "sainsburys_quiz"];
  const shouldShowTabs = !hiddenTags.some(tag => tags.includes(tag));

  if (shouldShowTabs) {
    tangent_custom_tabs.style.display = "flex";
  }
}


function customFunction(response) {
  if (!response?.product_sections?.section_UG_extras) {
    const container = document.getElementById("section_UG_extras_container");
    if (container) {
      container.style.display = "none";
    }
  }
}

function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango"
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              drawChart(response_json);
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}


function drawChart(params) {
  const attributeNames = ["Dryness", "Frizz", "Split Ends"];
  var selfie_conditions = params?.selfie_record[0]?.hairdamage?.attributes;
  if(selfie_conditions){
    var attr_list = [];
    for (const attributeName of attributeNames){
        attr_list.push({
            "x": attributeName.toUpperCase(),
            "value": getAttributeScore(selfie_conditions, attributeName)
        });
    }
    // create a chart
    drawRadarChart(attr_list);
  }
}
function getAttributeScore(attributeMap, attributeName, minimum=0.2){
   if(attributeMap.hasOwnProperty(attributeName)){
      return attributeMap[attributeName].score; 
    }
    return 1;
}

function drawRadarChart(list){
  setElementDisplay("chart-loading-section","none");
  var chart = anychart.radar();
  var interactivity = chart.interactivity();
  interactivity.hoverMode("bySpot");
  interactivity.spotRadius(0);

  chart.tooltip(false);
  chart.yScale().ticks().interval(1);
  chart.yScale().minimum(0);
  chart.yScale().maximum(5);
  chart.area(list).fill("rgba(239, 93, 140, 0.4)").stroke("rgba(239, 93, 140, 1)");


  var labels = chart.yAxis().labels();
  labels.enabled(false);
  chart.labels().fontFamily("Futura");
  chart.container("graph_container");
  chart.draw();
}

function setSelfieHairType(tags) {
  const el = document.getElementById("skin-type-text");

  const typeMap = {
    "1": "Straight",
    "2": "Wavy",
    "3": "Curly",
    "4": "Coily"
  };

  const subtypeOrder = {
    "2": ["2a", "2b", "2c"],
    "3": ["3a", "3b", "3c"],
    "4": ["4a", "4b", "4c"]
  };

  const normalized = tags.map(t => t.toLowerCase());

  let category = null;
  let subTypes = [];

  for (let key of ["1", "2", "3", "4"]) {
    if (normalized.some(t => t.startsWith(key))) {
      category = key;
      if (subtypeOrder[key]) {
        subTypes = normalized.filter(t => subtypeOrder[key].includes(t));
        subTypes.sort((a, b) => subtypeOrder[key].indexOf(a) - subtypeOrder[key].indexOf(b));
      }
      break;
    }
  }

  if (!category) {
    if (normalized.includes("straight")) category = "1";
    else if (normalized.includes("wavy")) category = "2";
    else if (normalized.includes("curly")) category = "3";
    else if (normalized.includes("coily")) category = "4";
  }

  // 🔹 Step 3: Show result
  if (category) {
    const subtypeText = subTypes.length ? ` (${subTypes.join(", ")})` : "";
    el.innerHTML = `Your hair type is ${typeMap[category]}${subtypeText}`;
  } else {
    el.innerHTML = "No hair type detected.";
  }
}

function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function copyToClipBoard(elementId){
  let discountCode = "QUIZ15";
  if(elementId=='full-routine-discount'){
    discountCode="QUIZEXTRA10";
  }
  navigator.clipboard.writeText(discountCode).then(() => {
     const popup = document.getElementById("copyPopup");
      popup.classList.add("show");
  
      setTimeout(() => {
        popup.classList.remove("show");
      }, 2000);
  }).catch(err => {
    console.error("Failed to copy:", err);
  });
}


function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
            
          // Track selected product variant
          tangent_selected_product_map[product.id] = variant.id;
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;

          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => variant.id === selectedVariantId) || productVariants[0];
  }
  
  return productVariants[0];
}

function getProductHTML(product, index, variant, section, sections) {
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant.image_id, product);
  const variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variant.id}`;
  let variantTitle= variant.title;
  if(variantTitle=="Default Title"){
    variantTitle="";
  }
  let buttonClass="";
  let buttonText = default_addToCartText;
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    buttonText = out_of_stock_text;
    buttonClass ="disable-button";
  }
  
  // Product View HTML using template literals
  const product_html = `
    <div>
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
        <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
        <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
        <p class="tangent_variant_title">${variantTitle}</p>
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${variant.price}</p>
      </a>
      <div id="${section}_variant_${index}"></div>
      <a class="tangent-product-add-btn-wrapper product-item" id="${variant.id}" href="javascript: void(0)">
        <p class="tangent-btn-add tangent_add_to_cart_button btn ${buttonClass}" id="${section}_cart_tangent_product_${index}_text">
          ${buttonText}
        </p>
      </a>
    </div>
  `;
  
  return product_html;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "active") {
      return false;
  }
  return variant.available_for_sale;
}

function setTabOpen(tags){
    // Setting 1st tab active by default
    document.querySelector("#tab-wrapper").style.display="block";
    // By Default first tab is selected and opened
    document.querySelectorAll(".tabcontent")[0].style.display="block";
    document.querySelectorAll(".tablinks")[0].classList.add("active");
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    // document.getElementById(section+"_cart_tangent_product_"+productno+"_text");
    if(btn.childNodes[1]!=undefined){
        btn.childNodes[1].innerHTML = default_addedToCartText;
        btn.childNodes[1].classList.add("added-to-cart-style"); 
    }    
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    if(section_name!="section_UG_extras" && section_name!="section_personal_reco_content" && section_name!="section_selfie"){
      section_container.classList.add("tabcontent");
    }
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_to_cart_p_tag;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      
      if(section_name!="section_UG_extras"){
        createTabButton(section_name);
      }
      
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_personal_reco_content"){
              var section_selfie = document.querySelector("#section_personal_reco_content_parent_container");
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

function setTangentSelfieSection(response) {
  hideLoading();

  const imageElement = document.querySelector('#tangent_selfie_image');
  const containerElement = document.querySelector('#tangent_selfie_container');
  const htmlContainer = document.getElementById("tangent_selfie_image_container");

  if (response?.selfie_html) {
    htmlContainer.innerHTML = response.selfie_html;
    return;
  }

  if (response?.selfie_url) {
    imageElement.src = response.selfie_url;
    containerElement.style.display = "flex";
    return;
  }

  const hairTypes = ["straight", "wavy", "curly", "coily"];
  const tags = Array.isArray(response?.tags) ? response.tags : [];
  const detectedTypes = hairTypes.filter(type => tags.includes(type));

  if (detectedTypes.length > 0) {
    const matchedType = detectedTypes[0];
    const imageUrl = tangent_default_selfie_image_url?.[matchedType];

    if (imageUrl) {
      imageElement.src = imageUrl;
      containerElement.style.display = "flex";
    } else {
      console.warn(`No image URL found for detected hair type: ${matchedType}`);
      containerElement.style.display = "none";
    }
  } else {
    console.warn("No matching hair types detected in response tags.");
    containerElement.style.display = "none";
  }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

function setElementDisplay(elementId, display){
  document.querySelector("#"+elementId).style.display = display;
}